import config from "../src/store/index";
export default {
  URL_ENDPOINT: "https://hermes-api.wtfapps.dev.br/api/v1",
  URL_IMAGE: "https://hermes-api.wtfapps.dev.br/",
  USER_TOKEN: config.state.user_data.token
};
